module.exports = __webpack_public_path__ + "static/img/riccardo-pelati-c-w3oVifZOw-unsplash_thumb.6fc98ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/riccardo-pelati-c-w3oVifZOw-unsplash_thumb.png
// module id = lhLb
// module chunks = 4